// extracted by mini-css-extract-plugin
export default {"container":"Sankey_container__KIvTs","tabelas":"Sankey_tabelas__jr3sL","table":"Sankey_table__0LSfc","invert":"Sankey_invert__8MGvz"};